import { render, staticRenderFns } from "./Error412.vue?vue&type=template&id=a90fb69c"
import script from "./Error412.vue?vue&type=script&lang=js"
export * from "./Error412.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports